module.exports = __webpack_public_path__ + "img/lab.8b89bdbc.svg";